export default {
  dial: 'Dial',
  message: 'Message',
  transfer: 'Transfer',
} as const;
